import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Palette, Factory, Package } from 'lucide-react';
import { Button } from './ui/Button';
export function HowItWorks() {
  const steps = [{
    number: '01',
    icon: <MessageSquare className="w-8 h-8" data-id="element-284" />,
    title: 'Tell Us What You Need',
    description: 'Share your vision, quantity, and timeline. We will guide you through options.',
    accentColor: 'pink' as const
  }, {
    number: '02',
    icon: <Palette className="w-8 h-8" data-id="element-285" />,
    title: 'We Design It',
    description: 'Our graphic design team creates or refines your artwork to print-ready perfection.',
    accentColor: 'yellow' as const
  }, {
    number: '03',
    icon: <Factory className="w-8 h-8" data-id="element-286" />,
    title: 'We Produce In-House',
    description: 'Everything is printed, embroidered, or engraved right here in our LaGrange facility.',
    accentColor: 'teal' as const
  }, {
    number: '04',
    icon: <Package className="w-8 h-8" data-id="element-287" />,
    title: 'Receive & Enjoy',
    description: 'We ship orders nationwide or arrange pickup when applicable.',
    accentColor: 'pink' as const
  }];
  const textColors = {
    pink: 'text-wh-pink',
    yellow: 'text-wh-yellow',
    teal: 'text-wh-teal'
  };
  const borderColors = {
    pink: 'border-wh-pink',
    yellow: 'border-wh-yellow',
    teal: 'border-wh-teal'
  };
  return <section className="py-24 bg-gray-50 border-t border-gray-100" data-id="element-288">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
        <div className="text-center mb-16" data-id="element-290">
          <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-291">
            Our Process
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-292">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-293">
            Our streamlined process makes custom apparel easy, from concept to
            delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-294">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-295">
              <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 h-full hover:shadow-md transition-shadow duration-300" data-id="element-296">
                <div className={`text-6xl font-bold mb-4 opacity-10 ${textColors[step.accentColor]}`} data-id="element-297">
                  {step.number}
                </div>
                <div className={`w-14 h-14 rounded-lg border-2 ${textColors[step.accentColor]} ${borderColors[step.accentColor]} flex items-center justify-center mb-6`} data-id="element-298">
                  {step.icon}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-299">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-300">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10" data-id="element-301">
                  <div className="w-8 h-0.5 bg-gray-200" data-id="element-302"></div>
                </div>}
            </div>)}
        </div>

        <div className="text-center" data-id="element-303">
          <Link to="/Contact" data-id="element-304">
            <Button variant="primary" size="lg" data-id="element-305">
              Get Started Today
            </Button>
          </Link>
          <p className="text-sm text-gray-500 mt-3" data-id="element-306">
            Simple, streamlined, and built around your timeline.
          </p>
        </div>
      </div>
    </section>;
}